import axios from "axios";

export const getDictionaries = () =>
  axios.get(`/api/dictionaries/getDictionaries`).then(response => {
    return response.data;
  });